module.exports = __webpack_public_path__ + "img/logo.4315ba6d.png";